import React, { Component } from 'react';
import IndexArchivos from '../index/IndexArchivos';

class Archivos extends Component {
	componentDidMount() {
		window.startx();
	}
	render() {
		return (
			<div id="main" className="wrapper style1">
				<div className="container">
					<header className="major">
						<h2>Programas Anuales de Desarrollo Archivístico</h2>
					</header>
					<div className="container">
						<div className="row">
							<div className="tabla col-12">
								<div className=" justificacion col-12">
									<div id="accordion">
										<div className="card">
											<div className="card-header titulo" id="headingOne">
												<h5 className="mb-0">
													<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
														Ejercicio 2022
													</button>
												</h5>
											</div>
											<div id="collapseOne" className="collapse fondo" aria-labelledby="headingOne" data-parent="#accordion">
												<div className="card-body">
													<div class="container">
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/PADA2022.pdf" target='_blank'>Programa Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/informePADA2022.pdf" target='_blank'>Informe Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="card">
											<div className="card-header titulo" id="headingFive">
												<h5 className="mb-0">
													<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
														Ejercicio 2023
													</button>
												</h5>
											</div>
											<div id="collapseTwo" className="collapse fondo" aria-labelledby="headingTwo" data-parent="#accordion">
												<div className="card-body">
													<div class="container">
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/PADA2023.pdf" target='_blank'>Programa Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/informePADA2023.pdf" target='_blank'>Informe Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="card">
											<div className="card-header titulo" id="headingThree">
												<h5 className="mb-0">
													<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
														Ejercicio 2024
													</button>
												</h5>
											</div>
											<div id="collapseThree" className="collapse fondo" aria-labelledby="headingThree" data-parent="#accordion">
												<div className="card-body">
													<div class="container">
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/PADA2024.pdf" target='_blank'>Programa Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/informePADA2024.pdf" target='_blank'>Informe Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="card">
											<div className="card-header titulo" id="headingFour">
												<h5 className="mb-0">
													<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
														Ejercicio 2025
													</button>
												</h5>
											</div>
											<div id="collapseFour" className="collapse fondo" aria-labelledby="headingFour" data-parent="#accordion">
												<div className="card-body">
													<div class="container">
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/PADA2025.pdf" target='_blank'>Programa Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/informePADA2025.pdf" target='_blank'>Informe Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="card">
											<div className="card-header titulo" id="headingFive">
												<h5 className="mb-0">
													<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
														Ejercicio 2026
													</button>
												</h5>
											</div>
											<div id="collapseFive" className="collapse fondo" aria-labelledby="headingFive" data-parent="#accordion">
												<div className="card-body">
													<div class="container">
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/PADA2026.pdf" target='_blank'>Programa Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
														<div class="panel-group">
															<div class="panel panel-default">
																<div class="panel-heading">
																	<h4 class="panel-title">
																		<a href="/PDF/informePADA2026.pdf" target='_blank'>Informe Anual de Desarrollo Archivístico</a>
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
	_renderCard = (armon) => {
		return IndexArchivos[armon].map((datos, i) => {
			return (
				<div className="card">
					<div className="card-header titulo" id={datos.ident}>
						<h5 className="mb-0">
							<button className="btn btn-link collapsed" data-toggle="collapse" data-target={"#collapse" + datos.ident} aria-expanded="false" aria-controls={"collapse" + datos.ident}>
								{datos.anio}
							</button>
						</h5>
					</div>
					<div id={"collapse" + datos.ident} className="collapse fondo" aria-labelledby={"heading" + datos.ident} data-parent="#accordion">
						<div className="card-body">
							<div class="container">
								<div class="panel-group">
									<div class="panel panel-default">
										<div class="panel-heading">
											<h4 class="panel-title">
												<a data-toggle="collapse" href={"#collapse1" + datos.ident}>{datos.trimestres}</a>
											</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		});
	};
}

export default Archivos;